import { API_URL } from "@/App.settings";
import IFactorBlockFeature from "@/interfaces/Config/Factor/IFactorBlockFeature";
import Factor from "@/types/Config/Factor";
import Dictionary from "@/types/Dictionary";
import TreeNode from "@/types/TreeNode";
import axios from "axios";
import Vue from "vue";
import Component from "vue-class-component";
import { InjectReactive, Prop, PropSync } from "vue-property-decorator";


/** Classe de base des traitements du FactorBlock */
@Component
export default class BaseFactorBlock<TFactor extends Factor = Factor> extends Vue {
    /** Variant de couleur à appliquer sur le composant */
    @Prop({ default: () => "secondary"})
    public Variant!: string;

    /** Facteur chargé par le FactorBlock */
    @PropSync('Factor')
    public factor: TFactor;

    /** Nom du facteur sélectionné */
    @Prop()
    public FactorLabel!: string;

//#region Gestion Factors.vue

    /** Liste des noeuds sélectionnées pour le calcul de facteur */
    protected checkedNodeIds: string[] = [];

    public get CheckedNodeIds(): string[] {
        return this.checkedNodeIds;
    }

    public set CheckedNodeIds(value: string[]) {
        this.checkedNodeIds = value;
    }

    /** Information du noeud sélectionné pour la liste des noeuds pour le calcul de facteur
     * Cette variable peut etre vide dans le cas d'évolution */
    protected selectionNode: TreeNode = {} as TreeNode;

    public get SelectedNode(): TreeNode {
        return this.selectionNode;
    }

    public set SelectedNode(value: TreeNode) {
        this.selectionNode = value;
    }

    /** Liste des noeuds sélectionnés dans l'arborescence principale */
    protected involvedNodes : TreeNode[] = [];

    public get InvolvedNodes(): TreeNode[] {
        return this.involvedNodes;
    }

    public set InvolvedNodes(value: TreeNode[]) {
        this.involvedNodes = value;
    }

    //#region Affichage ou non du composant Factors
    /** Indique si le composant Factors est visible ou non */
    protected factorsVisible: boolean = false;
    
    /** Indique si le composant Factors est visible ou non */
    public get FactorsVisible() {
        return this.factorsVisible;
    }

    /** Indique si le composant Factors est visible ou non
     * @description $emit('update:name' pour utilisation comme une PropSync()
     */
    public set FactorsVisible(value) {
        this.factorsVisible = value;
        // this.$emit('update:FactorsVisible', value);
    }
    /** #endregion Affichage ou non du composant Factors */

    /** Sélection automatique des noeuds ou faite par l'utilisateur */
    protected autoFilter: boolean = true;

    /** Indique que le calcul automatisé est en inadéquation avec l'arborescence principale */
    protected inWarning: boolean = false;

//#endregion Gestion Factors.vue

    // /** Liste des noeuds sélectionnées pour le calcul de facteur */
    // private checkedNodeIds!: string[];

	// public get CheckedNodesIds(): string[] {
	// 	return this.checkedNodeIds;
	// }

	// public set CheckedNodesIds(value: string[]) {
	// 	this.checkedNodeIds = value;
	// }

    // /** Information du noeud sélectionné pour la liste des noeuds pour le calcul de facteur
    //  * Cette variable peut etre vide dans le cas d'évolution */
    // public selectedNode!: TreeNode;

	// public get SelectedNode(): TreeNode {
	// 	return this.selectedNode;
	// }

	// public set SelectedNode(value: TreeNode) {
	// 	this.selectedNode = value;
	// }

    // //#region Affichage ou non du composant Factors
    // /** Indique si le composant Factors est visible ou non */
    // private factorsVisible: boolean = false;
    
    // /** Indique si le composant Factors est visible ou non */
    // public get FactorsVisible() {
    //     return this.factorsVisible;
    // }

    // /** Indique si le composant Factors est visible ou non
    //  * @description $emit('update:name' pour utilisation comme une PropSync()
    //  */
    // public set FactorsVisible(value) {
    //     this.$emit('update:FactorsVisible', value);
    // }
    //#endregion Affichage ou non du composant Factors

    /** Sélection automatique des noeuds ou faite par l'utilisateur */
	// protected autoFilter: boolean = true;

	// /** Indique que le calcul automatisé est en inadéquation avec l'arborescence principale */
	// protected inWarning: boolean = false;

    /**
     * Permet de comparer deux listes en les triant et comparant chaque élement present dans chacune d'elles
     * @param list1 
     * @param list2 
     */
    protected compareListes(list1, list2) {
        // Trie les deux listes
        list1.sort();
        list2.sort();

        console.debug("BaseFactorBlock - compareListes - list1 : %O | list2 : %O", list1, list2);

        // Compare les tailles des listes triées
        if (list1.length !== list2.length) {
            return false;
        }

        // Parcours de la première liste
        for (let i = 0; i < list1.length; i++) {
            // Si un élément de la seconde liste ne correspond pas
            if (list1[i] !== list2[i]) {
                return false;  
            }
        }

        return true;  // Si toutes les comparaisons réussissent
    }

    protected autoNodesChecker(val: TreeNode[]): DataAutoNodeChecker {
        let selectedNodes: TreeNode[] = [];
        // Noeuds ancêtres
        let ancestorNodes: TreeNode[] = [];
        // Noeuds descendants
        let descendantNodes: TreeNode[] = [];

        // Parcours de tous les noeuds de l'arborescence
        for (let treeNode of val) {
            // Vérification des noeuds à Affiliation = 0 (objet courant) ET que le noeud est bien coché (gestion noeuds exclus)
            if (treeNode.Checked && treeNode.Selections.findIndex(x => x.Affiliation === 0) != -1) {
                selectedNodes.push(treeNode);
            }
            // Vérification des noeuds à Affiliation = 2 (ancêtres) ET qui sont présents dans la liste des types d'objets autorisés.
            else if (treeNode.Selections.findIndex(x => x.Affiliation === 2) != -1 && this.objectTypes.findIndex(x => x === treeNode.ObjectType) != -1 ){
                ancestorNodes.push(treeNode);
            }
            // Vérification des noeuds à Affiliation = 1 (descendants) ET qui sont présents dans la liste des types d'objets autorisés ET que le noeud est bien coché (gestion noeuds exclus).
            else if (treeNode.Checked && treeNode.Selections.findIndex(x => x.Affiliation === 1) != -1 && this.objectTypes.findIndex(x => x === treeNode.ObjectType) != -1) {
                descendantNodes.push(treeNode);
            }
        }

        //Profondeur maximum des descendants
        let maximumDepth: number = descendantNodes.length > 0 ? descendantNodes.filter(d => Math.max(d.Depth))[0].Depth : 0;

        if (ancestorNodes.length > 0) {
            // On trie le tableau des ancêtres selon la variable LeftBound pour les parcourir à partir des noeuds les plus bas
            ancestorNodes.sort((a, b) => {
                return a.LeftBound > b.LeftBound ? -1 : 1;
            });
        }

        if (descendantNodes.length > 0) {
            //On trie le tableau des ancêtres selon la variable RightBound pour les parcourir à partir des noeuds les plus bas
            descendantNodes.sort((a, b) => {
                return a.LeftBound > b.LeftBound ? -1: 1;
            });
        }

        // Liste des noeuds à cocher
        let lAutoCheckedNodesIds: string[] = [];
        // Indication du mode erreur actif ou non
        let warning : boolean = false;

        // Parcours des noeuds sélectionnés
        for (let current of selectedNodes) {
            // On vérifie si le type d'objet du noeud selectionné est dans ceux autorisés par le facteur
            if (this.objectTypes.findIndex(x => x === current.ObjectType) != -1 ) {
                // On vérifie si l'identifiant du noeud est affecté au facteur et l'ajouter aux noeuds à cocher
                if (this.allocations.findIndex(x => x === current.Id) != -1)
                    lAutoCheckedNodesIds.push(current.Id);
                else {
                    warning = true;

                    // Liste des noeuds descendants à cocher
                    let ldescendantCheckedNodesIds : string[] = [];

                    for (let depth = current.Depth + 1; depth <= maximumDepth; depth++) {

                        ldescendantCheckedNodesIds = [];

                        for (let descendant of descendantNodes) {
                            // On vérifie les bornes du descendant sont inférieures à celui du noeud sélectionné avec profondeur + 1 
                            if (descendant.LeftBound > current.LeftBound && descendant.RightBound < current.RightBound 
                                && descendant.Depth == depth) {
                                // On vérifie si l'identifiant du descendant est affecté au facteur
                                if (this.allocations.findIndex(x => x === descendant.Id) != -1) {
                                    ldescendantCheckedNodesIds.push(descendant.Id);
                                }
                                else {
                                    // On vide la liste si pas d'affectations trouvés et on sort de la boucle
                                    ldescendantCheckedNodesIds = [];
                                    break;
                                }
                            }
                        }
                    }

                    if (ldescendantCheckedNodesIds.length == 0) {
                        for (let depth = current.Depth - 1; depth >= 1; depth--) {
                            // Parcours des ancêtres (rappel : on part des noeuds les plus bas)
                            for (let ancestor of ancestorNodes) {
                                // On vérifie si les bornes de l'ancêtre sont bien entre celles du noeud sélectionné
                                if (ancestor.LeftBound < current.LeftBound && ancestor.RightBound > current.RightBound
                                    && ancestor.Depth == depth) {
                                    // On vérifie si l'identifiant de l'ancêtre est affecté au facteur et l'ajouter aux noeuds à cocher
                                    if (this.allocations.findIndex(x => x === ancestor.Id) != -1) {
                                        lAutoCheckedNodesIds.push(ancestor.Id);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        for (let descendantNode of ldescendantCheckedNodesIds) {
                            lAutoCheckedNodesIds.push(descendantNode)
                        }
                    }
                }
            }
            else {
                // Indication présence d'un noeud non affecté
                let allocated = false;
                
                // Liste des noeuds descendants à cocher
                let ldescendantCheckedNodesIds : string[] = [];

                for(let depth = current.Depth + 1; depth <= maximumDepth; depth++){
                    ldescendantCheckedNodesIds = [];
                    //Parcours des descendants
                    for(let descendant of descendantNodes){
                        // On vérifie les bornes du descendant sont inférieures à celui du noeud sélectionné
                        if (descendant.LeftBound > current.LeftBound && descendant.RightBound < current.RightBound
                            && descendant.Depth == depth) {
                            // On vérifie si l'identifiant du descendant est affecté au facteur
                            if(this.allocations.findIndex(x => x === descendant.Id) != -1)
                                ldescendantCheckedNodesIds.push(descendant.Id);
                            else
                                warning = true;
                        }
                    }

                    if(ldescendantCheckedNodesIds.length > 0)
                        break;
                }

                if (ldescendantCheckedNodesIds.length == 0) {
                    for (let depth = current.Depth - 1; depth >= 1; depth--) {
                        // Parcours des ancêtres (rappel : on part des noeuds les plus bas)
                        for (let ancestor of ancestorNodes) {
                            // On vérifie si les bornes de l'ancêtre sont bien entre celles du noeud sélectionné
                            if (ancestor.LeftBound < current.LeftBound && ancestor.RightBound > current.RightBound
                                && ancestor.Depth == depth) {
                                // On vérifie si l'identifiant de l'ancêtre est affecté au facteur
                                if (this.allocations.findIndex(x => x === ancestor.Id) != -1) {
                                    lAutoCheckedNodesIds.push(ancestor.Id);
                                    allocated = true;
                                    break;
                                }
                            }
                        }

                        if (allocated)
                            break;
                    }

                    // S'il y a aucun noeud affecté, on passe en mode erreur 
                    if (!allocated)
                        warning = true; // inWarning

                } else {
                    for (let descendantNode of ldescendantCheckedNodesIds) {
                        lAutoCheckedNodesIds.push(descendantNode)
                    }
                }
            }
        }
        
        // S'il y a aucun noeud sélectionné, on passe en mode erreur
        if (val && val.length === 0)
            warning = true;

        // On supprime les valeurs en double présentes dans les noeuds 
        lAutoCheckedNodesIds = lAutoCheckedNodesIds.filter(function(item, pos) {
            return lAutoCheckedNodesIds.indexOf(item) == pos;
        });

        return { AutoCheckedNodeIds: lAutoCheckedNodesIds, InWarning: warning } as DataAutoNodeChecker;
    }

    //#region Gestion allocations et objectTypes
    
    /** Liste d'affectations */
    protected allocations: string[] = [];
    // public get Allocations(): string[] {
    //     return this.allocations;
    // }
    // public set Allocations(value: string[]) {
    //     this.allocations = value;
    // }

    /** Liste de type d'objets */
    protected objectTypes: string[] = [];

    // public get ObjectTypes(): string[] {
    //     return this.objectTypes;
    // }
    // public set ObjectTypes(value: string[]) {
    //     this.objectTypes = value;
    // }
    

    /** Reçoit d'un parent le nom de l'instance de FilterTree à utiliser comme base de clonage pour tous les composants enfants du Workbench */
    @InjectReactive()
    protected sourceFilterTree!: string;

    private unwatchSourceFilterTree = undefined;

    async created() {
        //#region Gestion des noeuds affectés pour le facteur
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["FactorId"] = this.factor.Id;

        /** @todo A déplacer à l'ouverture de Factors.vue */
        await axios.post(API_URL + "Feature/GetAllocationsFactor", args).then((response) => {  
            if (response && response.data) {
                this.allocations = response.data["allocations"];
                this.objectTypes = response.data["objectTypes"];
            }
        });

        console.debug("FactorBlock - created - avant watcher");

        /** Calcul des noeuds sélectionnés */
        this.unwatchSourceFilterTree = this.$store.watch((state, getters) => getters[this.sourceFilterTree + '/InvolvedNodes'], (val: TreeNode[], oldValue: TreeNode[]) => {
            /** Obligé de tester si les InvolvedNodes sont différents car le watcher se déclenche lors du clone de l'arborescence dans FilterTreeBuilder lors du this.$store.registerModule(this.filterTreeStore, FilterTree);
             * @see https://github.com/vuejs/vuex/issues/524 */
            
            if (JSON.stringify(val) != JSON.stringify(oldValue)) {
                console.debug("FactorBlock - created - init val : %O - objectTypes : %O - oldValue : %O - this.sourceFilterTree : %s", val, this.objectTypes, oldValue, this.sourceFilterTree);

                // this.factorBlockFeature().UpdateByInvolvedNodes(val, this.objectTypes, this.allocations);

                /** @todo Vérifier si ça marche bien... Faire plutôt en sorte que BaseFactorBlock implémente IFactorBlockFeature ???!!! */
                (this as unknown as IFactorBlockFeature).UpdateByInvolvedNodes(val);
            }
        }, { immediate: true });
        //#endregion Gestion des noeuds affectés pour le facteur
    }

    beforeDestroy() {
        if (this.unwatchSourceFilterTree)
            this.unwatchSourceFilterTree();
    }
    //#endregion Gestion allocations et objectTypes
}

export class DataAutoNodeChecker {
    AutoCheckedNodeIds: string[];
    InWarning: boolean;
}